// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import Datepicker from './Datepicker'

const Label = styled.div`
  margin-top: 5px;
  padding: 3px 0;
  font-size: 12px;
  color: gray;
`
const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  margin-left: auto;
`
const StyledDatepicker: any = styled(Datepicker)`
  height: 35px;
  width: 200px !important;

  &:disabled {
    color: #aaa;
  }
  font-size: 14px;
`

const t = {
  period: 'Статистика за'
}

type Props = {|
  initialDate: string,
  separator: string,
  origin: string,
  disabled: boolean,
  onChange: Function
|}

export default class FilterDatepicker extends Component<Props> {
  render() {
    const { initialDate, separator, origin, disabled, onChange } = this.props
    return (
      <Wrapper>
        <Label>{t.period}</Label>
        <StyledDatepicker
          data={{
            initial: initialDate,
            separator,
            origin
          }}
          disabled={disabled}
          onChange={(value) => onChange(value)}
        />
      </Wrapper>
    )
  }
}
